import { render } from "./ArrayImagesField.vue?vue&type=template&id=5ebf3f9e"
import script from "./ArrayImagesField.vue?vue&type=script&lang=js"
export * from "./ArrayImagesField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ArrayImagesField.vue"]])

export default __exports__